// extracted by mini-css-extract-plugin
export default {"container":"sign-up-page_container__wZSjn","form":"sign-up-page_form__-Bka6"};